<template>
  <div class="register-view">
    <ContentLayout>
      <h1 class="register-view__heading">
        <Heading :value="formSettings.title" />
      </h1>
      <div class="register-view__form">
        <FormContainer />
        <ModalLauncher
          @click="_setModalData"
          :description="formSettings.gdpr.title"
        />
      </div>
    </ContentLayout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
import { loadProgramData } from "@/utils";
import { Routes } from "@/constants";

import FormContainer from "@/containers/FormContainer";
import ModalLauncher from "@/components/ModalLauncher";
import Heading from "@/components/Heading";
import ContentLayout from "@/layouts/ContentLayout";

export default {
  name: "RegisterView",
  components: {
    FormContainer,
    Heading,
    ContentLayout,
    ModalLauncher
  },
  computed: {
    ...mapState({
      formSettings: state => state.registrationFormSettings
    })
  },
  methods: {
    ...mapActions({
      triggerScrollTop: "triggerScrollTop",
      setModalData: "setModalData"
    }),
    _setModalData: function() {
      this.setModalData({
        content: this.formSettings.gdpr.description,
        close_label: this.formSettings.gdpr.button_label
      });
    }
  },
  beforeCreate() {
    if (!loadProgramData(store.state.resultProgram)) {
      this.$router.push(Routes.loading.path);
    }
  },
  mounted() {
    this.triggerScrollTop();
  }
};
</script>

<style lang="scss" scoped>
.register-view {
  height: 100%;
  width: 100%;

  &__heading {
    animation: enterHeading 1.2s ease;
    margin-bottom: spacer("l");

    @keyframes enterHeading {
      0% {
        opacity: 0;
        transform: translateY(-100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  &__form {
    align-items: center;
    animation: enterForm 1.2s ease;
    display: flex;
    flex-direction: column;
    padding-bottom: 100px;
    padding: 0 spacer("m") spacer("l");
    width: 100%;

    @include if-tablet {
      width: 500px;
      padding: 0 0 spacer("m");
    }

    @keyframes enterForm {
      0% {
        opacity: 0;
        transform: translateY(80px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}
</style>
